import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingScreen = () => {
  return /*#__PURE__*/_jsx("div", {
    className: `absolute top-0 left-0 z-[10000] w-full h-full`,
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      height: '100%',
      background: "white"
    })
  });
};
export default LoadingScreen;